import { Container, Group, SectionBanner, Text, useBreakpoint } from '@melio/penny';
import { useAnalytics } from '@melio/platform-analytics';
import { useMelioIntl } from '@melio/platform-provider';
import React from 'react';

import { FileAttachmentWidget } from '../FileAttachment';
import { PaymentRequestDetailsForm } from './PaymentRequestDetailsForm';
import { PaymentRequestDetailsWidgetProps } from './types';

export const PaymentRequestDetailsWidget = ({
  paymentRequest,
  showOpenBalance,
  ...props
}: PaymentRequestDetailsWidgetProps) => {
  const { isExtraSmallScreen } = useBreakpoint();
  const { track } = useAnalytics();
  const { formatMessage, formatCurrency } = useMelioIntl();

  return (
    <Container border="regular" data-component="PaymentRequestDetailsWidget" {...props}>
      <Group hasDivider variant="vertical" spacing="none">
        <Container paddingX={isExtraSmallScreen ? 's' : 'xl'} paddingY="l">
          <Group variant="vertical" spacing="l">
            <SectionBanner
              description={formatMessage('widgets.paymentRequestDetails.banner.description', {
                vendorName: paymentRequest.vendor?.name ?? '',
              })}
            />
            <Container data-component="PaymentRequestDetailsHeader" paddingY="xxs">
              <Text textStyle="heading2Semi">{formatMessage('widgets.paymentRequestDetails.header.title')}</Text>
            </Container>
            <Group variant={isExtraSmallScreen ? 'vertical' : 'horizontal'} spacing="l" alignItems="flex-start">
              <PaymentRequestDetailsForm paymentRequest={paymentRequest} />
              <FileAttachmentWidget
                file={paymentRequest.file}
                isViewMode
                onViewModeClick={(fileUrl) => {
                  if (fileUrl) {
                    track('PaymentRequest', 'Click', { Intent: 'download-file', Cta: 'download-file' });
                    window.open(fileUrl);
                  }
                }}
              />
            </Group>
          </Group>
        </Container>
        {showOpenBalance && (
          <Container
            backgroundColor="light"
            paddingX={isExtraSmallScreen ? 's' : 'xl'}
            paddingY="l"
            data-component="OpenBalance"
          >
            <Group justifyContent="space-between">
              <Text textStyle="heading2">{formatMessage('widgets.paymentRequestDetails.openBalance')}</Text>
              <Text textStyle="heading2">{formatCurrency(paymentRequest.totalAmount)}</Text>
            </Group>
          </Container>
        )}
      </Group>
    </Container>
  );
};

PaymentRequestDetailsWidget.displayName = 'PaymentRequestDetailsWidget';
